import registerServiceWorker from '@src/registerServiceWorker';
import * as React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
// add i18n react-intl modules
import { addLocaleData, IntlProvider } from 'react-intl';
import en from 'react-intl/locale-data/en';
import fr from 'react-intl/locale-data/fr';
import 'react-dates/lib/css/_datepicker.css';
// import './app/_styles/index.scss';
import store from '@src/store';
import { Main } from '@src/app/main/Main';

addLocaleData([...en, ...fr]);

const locale =
  (navigator.languages && navigator.languages[0]) ||
  navigator.language ||
  // tslint:disable-next-line:no-string-literal
  window.navigator['userLanguage'] ||
  'en-US';

let messages;
try {
  messages = require(`./translations/${locale}.json`);
  messages = messages.messages;
} catch (err) {
  console.log(err);
}
const Root = (
  <Provider store={store}>
    <IntlProvider defaultLocale="en-US" locale={locale} messages={messages}>
      <Main />
    </IntlProvider>
  </Provider>
);

render(Root, document.getElementById('root'));
registerServiceWorker();
